
  document.addEventListener("DOMContentLoaded", function() {
    // Map old Shopify section IDs to your preferred custom IDs
    const sections = {
      "shopify-section-template--19025020977320__image_with_text_aWrHR3": "rebates",
      "shopify-section-template--19025020977320__custom_content_PGdWCg": "convenience-and-availability",
      "shopify-section-template--19025020977320__image_with_text_8HWeWt": "multiple-applications",
      "shopify-section-template--19025020977320__custom_content_rnk3Ah": "privacy-and-hygiene",
      "shopify-section-template--19025020977320__image_with_text_8yVULR": "long-term-savings",
      "shopify-section-template--19025020977320__custom_content_7xCqLT": "customised-experience",
      "shopify-section-template--19025020977320__image_with_text_LFBizP": "well-being"
      // Add more mappings as needed
    };

    for (const [oldId, newId] of Object.entries(sections)) {
      const el = document.getElementById(oldId);
      if (el) el.id = newId;
    }
  });
